export default {
      id: "icon-difficulte2-usage",
      viewBox: "0 0 103 30",
      url: __webpack_public_path__ + "icons.svg#icon-difficulte2",
      toString: function () {
        return this.url;
      }
    }